export class CsColorHelper {
    static getTextColorForBackground(backgroundColor: string): string {
        const color = (backgroundColor.charAt(0) === '#') ? backgroundColor.substring(1, 7) : backgroundColor;
        const r = parseInt(color.substring(0, 2), 16);
        const g = parseInt(color.substring(2, 4), 16);
        const b = parseInt(color.substring(4, 6), 16);

        // Calculate brightness
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;

        if (brightness < 128) {
            // If background color is dark, use white text
            return 'white';
        } else if (backgroundColor.toLowerCase() === '#ffffff' || backgroundColor.toLowerCase() === 'white') {
            // If background is white, use black text
            return 'black';
        } else {
            const factor = 0.35; // Adjust for darker shade
            const darkerR = Math.floor(r * factor);
            const darkerG = Math.floor(g * factor);
            const darkerB = Math.floor(b * factor);

            return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
        }
    }
}
